/**
 * ContentPreview Component
 *
 * Displays content thumbnail. Used as a placeholder until video playback starts.
 */

import React from 'react';
import { ContentThumbnail } from './ContentThumbnail';
import { qaAttr, type QaAttrOptions } from '@/presentation/utils/qaAttr';

export interface ContentPreviewProps {
  /** Thumbnail image URL */
  thumbnailUrl: string | null | undefined;

  /** Alt text for the thumbnail */
  alt?: string;

  /** Whether the preview is clickable */
  isClickable?: boolean;

  /** Click handler */
  onClick?: () => void;

  /** Custom CSS class */
  className?: string;

  /**
   * Optional QA tag for the clickable thumbnail surface (`data-qa-id`), so the
   * `qa-tester` agent can locate and click a content thumbnail.
   */
  qa?: QaAttrOptions;
}

export const ContentPreview: React.FC<ContentPreviewProps> = ({
  thumbnailUrl,
  alt = 'Video thumbnail',
  isClickable = false,
  onClick,
  className = '',
  qa,
}) => {
  return (
    <div
      {...(qa ? qaAttr(qa) : {})}
      className={`relative w-full h-full ${isClickable ? 'cursor-pointer' : ''} ${className}`}
      onClick={isClickable ? onClick : undefined}
    >
      <ContentThumbnail
        thumbnailUrl={thumbnailUrl}
        alt={alt}
      />
    </div>
  );
};
